module.exports = __webpack_public_path__ + "media/images/theme-logo-8c57c962.svg";